var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Sorter-Image-Download"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Images Download")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Shipping Id's ")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('shippingId')
    },
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "name": "shippingId",
      "rows": "10",
      "max-rows": "10",
      "id": "shippingId",
      "placeholder": "Enter ShippingID, Use Comma For Multiple ShippingID"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shippingId')),
      expression: "errors.has('shippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('shippingId')))]), _vm._v(" "), (_vm.shipmentLimt) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shipmentLimtMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "15px"
    }
  }, [_c('label', [_vm._v("Select file ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "uploadFile"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Upload ")]), _vm._v("  \n                "), _c('b-button', {
    staticClass: "-common-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Display On Screen")]), _vm._v("  \n                "), _c('b-button', {
    staticClass: "-common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getBatchDetails()
      }
    }
  }, [_vm._v("Show Batches")]), _vm._v("  \n                "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * For upload shipping id, only CSV file allowed.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("           * Zip will be generated only if less than 1000 shipping IDs are entered or uploaded.")])], 1)], 1)])])])], 1), _vm._v(" "), (_vm.shipmentTable == true) ? _c('div', [_c('b-card', [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BatchId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentData), function(data, index) {
    return (_vm.shipmentData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showImageDetails(data.batchId)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(data.shippingIds.length))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.batchTime[data.batchId] && data.status == 'InProcess'),
        expression: "batchTime[data.batchId] && data.status=='InProcess'"
      }],
      staticStyle: {
        "color": "rgb(24,142,0)",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Update batch to process/ download Zip"
      },
      on: {
        "click": function($event) {
          return _vm.updateBatchStatus(data)
        }
      }
    }, [_c('b', [_vm._v("Update Status")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['Close', 'Done', 'Error'].includes(data.status)),
        expression: "['Close','Done','Error'].includes(data.status)"
      }],
      staticStyle: {
        "color": "rgb(22, 69, 208)",
        "cursor": "pointer",
        "margin": "10px 10px 10px 10px"
      },
      attrs: {
        "title": "Export Image URL in CSV"
      },
      on: {
        "click": function($event) {
          return _vm.exportImageUrl(data.shippingIds)
        }
      }
    }, [_c('b', [_vm._v("Export CSV "), _c('i', {
      staticClass: "fa fa-file"
    })])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.status == 'Done' && data.shippingIds.length <= 1000),
        expression: "data.status=='Done' && data.shippingIds.length<=1000"
      }],
      staticStyle: {
        "color": "rgb(208,101,22)",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Download Zip"
      },
      on: {
        "click": function($event) {
          return _vm.downloadZip(data.zipped)
        }
      }
    }, [_c('b', [_vm._v("Download Zip "), _c('i', {
      staticClass: "fa fa-download"
    })])])])]) : _vm._e()
  }), 0)])]), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showShipmentDetils == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Shipment Image details"
    },
    model: {
      value: (_vm.showShipmentDetils),
      callback: function($$v) {
        _vm.showShipmentDetils = $$v
      },
      expression: "showShipmentDetils"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shipment Image details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipping Id "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.searcShippingId),
      expression: "searcShippingId"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('searcShippingId')
    },
    attrs: {
      "id": "searcShippingId",
      "type": "text",
      "name": "searcShippingId",
      "placeholder": "Enter Shipping Id"
    },
    domProps: {
      "value": (_vm.searcShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searcShippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "ssId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn-sm btn-primary",
    staticStyle: {
      "margin-top": "13%"
    },
    attrs: {
      "title": "Search Shipping Id",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getSearchedShipments()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn-sm btn-danger",
    staticStyle: {
      "margin-top": "13%"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.resetShipping()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.shipIdLoading
    },
    on: {
      "update:active": function($event) {
        _vm.shipIdLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Image Url")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Check Flag")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentImageData), function(data, index) {
    return (_vm.shipmentImageData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Download Image"
      },
      on: {
        "click": function($event) {
          return _vm.downloadImage(data, index)
        }
      }
    }, [_vm._v(_vm._s(data.imageUrlPath))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.checkFlag))])]) : _vm._e()
  }), _vm._v(" "), (_vm.shipmentImageData.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])], 1)], 1)])], 1) : _vm._e()], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4203353d","hasScoped":true}!./src/views/components/SorterImageDownload/SorterImageDownload.html
// module id = 1399
// module chunks = 2